import React from 'react';
import ReactDOM from 'react-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AuthApp from './components/AuthApp';
import PublicRules from './components/PublicRules';
import AccountProvider from './contexts/account';
import FlashMessageProvider from './contexts/flashMessage';
import ToggleProvider from './contexts/toggle';
import theme from './theme';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Routes>
          <Route path="/rules/*" element={<PublicRules />} />
          <Route
            path="*"
            element={
              <FlashMessageProvider>
                <AccountProvider>
                  <ToggleProvider>
                    <AuthApp />
                  </ToggleProvider>
                </AccountProvider>
              </FlashMessageProvider>
            }
          />
        </Routes>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);
